module.exports = __webpack_public_path__ + "img/MGH-Roppongi-2.fa61e26a.jpg";